export const assessmentTemplate = [
  {
    _id: "botpressFBPlayerTeams",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "rlund3",
      createdDate: "2025-12-10T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "botpressFBPlayerTeams",
      omniTypeVersion: 1,
      title: "Questions about Football Players and Teams",
      description: "This is a collection of football-related queries about players and teams.",
      duration: "A little less than a bit",
      directions: "Do not close your browser window until the assessment is complete.",
      attribution: "Omniscia AI Team. All Rights Reserved.",
      validated: true,
      selfAssessment: true,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "FOOT016",
          numberText: "16",
          text: "How many players are on a team?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT017",
          numberText: "17",
          text: "What is the minimum number of players?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT018",
          numberText: "18",
          text: "How many substitutes are allowed?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT019",
          numberText: "19",
          text: "When can substitutions be made?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT020",
          numberText: "20",
          text: "What is a goalkeeper allowed to do?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT021",
          numberText: "21",
          text: "Can the goalkeeper use hands?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT022",
          numberText: "22",
          text: "Can a player change positions?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT023",
          numberText: "23",
          text: "What happens if a player is injured?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT024",
          numberText: "24",
          text: "Can a player re-enter after substitution?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT025",
          numberText: "25",
          text: "What equipment is required?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT026",
          numberText: "26",
          text: "Are shin guards mandatory?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT027",
          numberText: "27",
          text: "Can players wear jewelry?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT028",
          numberText: "28",
          text: "What is a captain’s role?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT029",
          numberText: "29",
          text: "Can a team play without a goalkeeper?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT030",
          numberText: "30",
          text: "What happens if a team has too many players?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
      ],

      assessmentResults: {
        finalResult: null,
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "botpressFBPlayerTeams",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
